import { ProviderDepositProduct } from './provider-deposit-product';

export class OfflineProduct {
    public providerOfflineProductID: number;
    public orderID: number;
    public orderCode: string;
    public sku: string;
    public unit: string;
    public quantity: number;
    public productName: string;
    public isValid: boolean;
    public gtinList: string[];
    public vat: number;
    public markupPrice: number;
    public price: number;
    public productPhotoID: string;
    public providerProductImageURL: string;
    public categoryNameToDisplayTranslationCode: string;
    public shelfPositionDisplayNameKey: string;
    public productLocationMapImageUrl: string;
    public shelfDisplayNameKey: string;
    public sequenceOrder?: number;
    public multipickingTaskIdentifierChar: string;
    public multipickingTaskIdentifierColor: string;
    public isWerwProduct: boolean;
    public isPriceForced: boolean;
    public isBulk: boolean;
    public productProviderID: number;
    public providerDepositProductList: ProviderDepositProduct[];
}
